import { AssetProperty } from '@api/model/assetProperty';
import { isValidJSON } from '../../extensions/string.extensions';
import { IMenuModel } from './models/IMenuModel';

export class PropertiesOverview {
    public static menus: IMenuModel[];
    public static ids = new Map<string, IMenuModel>();

    public static generateIds(menus: IMenuModel[]) {
        if (menus == null) {
            return;
        }

        for (const menu of menus) {
            this.ids.set(menu.id, menu);

            if (menu.submenus.length) {
                this.generateIds(menu.submenus);
            }
        }
    }

    public static toggle(menuId: string) {
        const element = document.getElementById(menuId);
        let value = element.getAttribute('value') === 'true';
        value = !value;
        element.setAttribute('value', String(value));
    }

    public static getToggleState(elementId: string): boolean {
        const state = document.getElementById(elementId)?.getAttribute('value') === 'true';
        return state;
    }

    public static getFlattenedProperties(propertyValues: AssetProperty[]) {
        const stringReportedProperties = propertyValues
            .filter((entity) => !isValidJSON(entity.reportedValue))
            .reduce(
                (obj, value) => ({
                    ...obj,
                    [value.name]: value.reportedValue,
                }),
                {}
            );

        const validProps = propertyValues.filter((entity) => isValidJSON(entity.reportedValue)).map((entity) => ({ ...entity, reportedValue: JSON.parse(entity.reportedValue) }));

        const simpleProps = validProps
            .filter((entity) => Object.keys(entity.reportedValue).length == 0)
            .reduce(
                (obj, value) => ({
                    ...obj,
                    [value.name]: value.reportedValue,
                }),
                {}
            );

        const complexreportedProperties = validProps
            .filter((entity) => Object.keys(entity.reportedValue).length > 0)
            .reduce(
                (obj, value) => ({
                    ...obj,
                    ...value.reportedValue,
                }),
                {}
            );
        return { ...stringReportedProperties, ...simpleProps, ...complexreportedProperties };
    }
}
